import { db } from '../../../firebase';
import {
  FETCH_MINUTES_STARTED,
  FETCH_MINUTES_COMPLETED,
  FETCH_MINUTES_ERROR
} from '../../actionTypes/chittieAuctionActionTypes';

export const fetchMinutesStart = () => ({
  type: FETCH_MINUTES_STARTED
});
export const fetchMinutesSuccess = (data) => ({
  type: FETCH_MINUTES_COMPLETED,
  payLoad: data
});
export const fetchMinutesFailure = () => ({
  type: FETCH_MINUTES_ERROR
});

export const fetchMinutes = () => {
  return (dispatch) => {
    dispatch(fetchMinutesStart());
    db.fetchMinutes()
      .then((snapShot) => {
        let minutes = {};
        if (snapShot.val()) {
          minutes = snapShot.val();
        }
        dispatch(fetchMinutesSuccess(minutes));
      })
      .catch((error) => {
        dispatch(fetchMinutesFailure(error));
      });
  };
};



// WEBPACK FOOTER //
// ./src/redux/actions/ChittieAuctionActions/fetchMinutes.js